import React from 'react';
import { useStoreState } from 'easy-peasy';
import { toast } from 'react-toastify';

import Layout from '../../../components/global/Layout';
import { fetchNotificationCampaigns } from './helpers';
import EmailCampaignForm from './EmailCampaignForm';

const UpdateEmailCampaignTemplate = ({ history, match }) => {
  const { templateId } = match.params;
  const { userId } = useStoreState(state => state.auth);

  const [loading, setLoading] = React.useState(false);
  const [campaign, setCampaign] = React.useState();

  React.useEffect(() => {
    const fetchFunc = async () => {
      setLoading(true);
      try {
        const res = await fetchNotificationCampaigns({
          userId,
          templateId,
        });
        if (res) {
          setCampaign(res);
        } else {
          toast.error('Could Not Fetch Campaign Template!');
        }
        setLoading(false);
      } catch {
        setLoading(false);
        toast.error('Could Not Fetch Campaign Template!');
      }
    };
    fetchFunc();
  }, []);

  if (loading) {
    return (
      <Layout>
        <span style={{ color: '#00AEEF', padding: '20px' }}>Loading...</span>
      </Layout>
    );
  }

  if (campaign && !campaign?.csv_url) {
    return (
      <Layout>
        <div className="m-2 p-2">
          <p className="has-text-danger is-size-2">
            We can&apos;t update this campaign at the moment — something&apos;s
            gone a bit pear-shaped on our end!
          </p>
          <br />
          <a onClick={() => history?.goBack()} className="button is-grey">
            <span className="has-text-weight-semibold">Cancel</span>
          </a>
        </div>
      </Layout>
    );
  }

  return campaign ? (
    <EmailCampaignForm
      isUpdate
      history={history}
      userId={userId}
      templateId={campaign.template_id}
      title={campaign.title}
      platform={campaign.platform}
      copyEmails={campaign.copy_emails}
      replyTo={campaign.reply_to}
      notificationCampaignId={campaign.notification_campaign_id}
      csvUrl={campaign.csv_url}
      csvkey={campaign.csv_key}
      canUpdate={false}
      status={campaign.status}
    />
  ) : (
    <></>
  );
};

export default UpdateEmailCampaignTemplate;
